export class KeyExistsError extends Error {
	public static readonly keyExistsText = "The key already exists in collection";

	constructor(public key: string, message: string) {
		super(`${message}:${key}`);
		Object.setPrototypeOf(this, KeyExistsError.prototype);
	}
}